import { Box, Button, CircularProgress } from "@mui/material";
import { InfoBar } from "../../shared/infoBar";
import { ErrorHeader } from "../../shared/errorHeader";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MiniGrid, RowItem } from "../../shared/miniGrid";
import { useApiCallWithAuth } from "../../hooks/useApiCallWithAuth";
import { generateCustomProgramApi, getSingleOrgSeasonApi } from "../../api/orgSeasonApi";
import { OrgSeason } from "../../api/models/orgSeason";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppUser } from "../../providers/appUserContext";
import { BasicButton } from "../../shared/basicButton";
import { Team } from "../../api/models/team";
import { ProgramOptions } from "../../api/models/program";


export function ManageProgramPage() {
    const [orgSeason, setOrgSeason] = useState<OrgSeason | undefined>(undefined);
    const [programs, setPrograms] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [programRows, setProgramRows] = useState<RowItem[] | undefined>(undefined);

    const params = useParams();

    const navigate = useNavigate();
    const { isAuthenticated } = useAuth0();
    const { appUser, getPermission, isAdmin, refreshAppUser } = useAppUser();

    const getOrgSeasonApiRequest = useApiCallWithAuth(getSingleOrgSeasonApi);
    const generateCustomProgramApiRequest = useApiCallWithAuth(generateCustomProgramApi);

    const navigateUrl = (params.orgSeasonGuid && params.teamGuid) ? `/orgseason/${params.orgSeasonGuid}/team/${params.teamGuid}` : '';
   

    useEffect(() => {
        if (!params.orgSeasonGuid) {
            throw Error('OrgSeason Guid is missing');
        }

        console.log(`isAuthenticated: ${isAuthenticated}, isAdmin: ${isAdmin(params.orgSeasonGuid)}`);

        if (!isAuthenticated || !isAdmin(params.orgSeasonGuid)) {
            setErrorMessage('You do not have permission to access this page X');
            return;
        }

        initPage();
    }, [isAuthenticated, isAdmin, params.orgSeasonGuid]);

    async function initPage() {
        setIsLoading(true);
        setErrorMessage('');

        try {
            const fetchOrgSeason = (await getOrgSeasonApiRequest.request(params.orgSeasonGuid)) as OrgSeason;
            if (fetchOrgSeason) {



                
                setOrgSeason(fetchOrgSeason);
                const team = fetchOrgSeason.teams.find((team: Team) => team.id === params.teamGuid);

                if (team) {
                    if (team.programOptions && team.programOptions.length > 0) {
                        setPrograms(team.programOptions);
                        mapProgramsToRows(team.programOptions);
                    }
                }


            }
            else {
                setErrorMessage(`orgSeason ${params.orgSeasonGuid} not found`);
            }
        } catch (error: any) {
            setErrorMessage(error.message);
        }

        setIsLoading(false);
    }

    function mapProgramsToRows(responsePrograms: ProgramOptions[]) {

        if (responsePrograms && responsePrograms.length > 0) {
            const tempRows = responsePrograms.map((rowItem) => ({
                id: rowItem.customProgramGuid,
                items: [{ name: 'Name', value: rowItem.name },
                { name: 'Theme', value: rowItem.theme },
                { name: 'Members Per Page', value: rowItem.membersPerPage.toString() },
                { name: 'Games Per Page', value: rowItem.gamesPerPage.toString() },

                ]
            }));

            setProgramRows(tempRows);

        }
    }

    async function navigateToaddProgramPage(): Promise<boolean> {

        if (params.orgSeasonGuid && params.teamGuid) {
            navigate(`/orgseason/${params.orgSeasonGuid}/team/${params.teamGuid}/program/form`);
        }
        return true;
    }

    async function navigateToEditProgramPage(programId: string): Promise<boolean> {

        if (params.orgSeasonGuid && params.teamGuid) {
            navigate(`/orgseason/${params.orgSeasonGuid}/team/${params.teamGuid}/program/form/${programId}`);
        }
        return true;
    }

    async function handleDeleteProgram(programId: string): Promise<boolean> {

        return true;
    }


    const mainContent = () => {
        return (
            <Box>
                <BasicButton onClick={() => navigateToaddProgramPage()} labelText={"Add Program"} />
                {!programRows && <Box>No programs found for this team.</Box>}
                {programRows && <MiniGrid rows={programRows} width={1200}
                    onEdit={navigateToEditProgramPage}
                    onDelete={handleDeleteProgram} />}
            </Box>
        );
    };

    return (<Box>
        <InfoBar navigateUrl={navigateUrl} />
        <ErrorHeader errorMessage={errorMessage} />
        {isLoading && <CircularProgress />}
        {orgSeason && mainContent()}
    </Box>
    );

}